import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from '../../common/withRouter';
import {
  Loader,
  ButtonOBSOLETED,
  Notification,
  Message,
} from "../../web.common";
import { LayoutContext } from "../layout/siteLayout";
import PageTop from "../layout/PageTop";
import withApi from "../higherOrderComponents/withApi";
import {
  Filters,
  FilterInput,
  FilterSelect,
  FilterTimePicker,
} from "./Filters";
import { getQueryStringParameters } from "../../common/utils";
import { DisplayDate, DisplayGuid, DisplayType } from "../items";

const RelayRulesInternal = (props) => {
  const [loadedData, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const navigationButtonStyle = {
    width: "6%",
    color: "grey",
    fontSize: "0.85rem",
  };

  const clickable ={
    cursor: "pointer"
  }

  useEffect(() => {
    async function loadFromApi() {      
      loadData();
    }
    if (!loadedData) {
      loadFromApi();
    }
  },[]);

  const loadData = async () => {
    setIsLoading(false);
    const { history, location } = props;
    const filters = getQueryStringParameters(location.search);
    const data = await props.api.relayRules.searchRules({
      filters
    });

    setData(data);

    setIsLoading(true);
  };

  const deleteRule = async (event,ruleId) => {
    event.stopPropagation();
    await props.api.relayRules.deleteRule(ruleId);
    loadData();
  };

  const relayTypes = [
  {
    value: "BadInfo",
    label: "BadInfo",
  },
  {
    value: "Parse",
    label: "Parse",
  },
  {
    value: "Irrelevant",
    label: "Irrelevant",
  },
  {
    value: "IsSignup",
    label: "IsSignup",
  },
  {
    value: "IsCancellation",
    label: "IsCancellation",
  },
  {
    value: "Warning",
    label: "Warning",
  }
];

  const filters = getQueryStringParameters(location.search);
  const page = parseInt(filters.page) || 1;
  const orderBy = filters.orderBy || "name";
  const orderDirection = filters.orderDirection || "asc";
  
  const orderHandler = (name) => {
    const { history, location } = props;
    let direction;
    if (name.toLowerCase() === orderBy.toLowerCase()) {
      direction = orderDirection === "desc" ? "asc" : "desc";
    } else {
      direction = "asc";
    }
 
    Filters.goToPage(history, location, page, name, direction);
  }

  const pagingHandler = async (action) => {
    const { history, location } = props;
    
      if (page < loadedData.pages && action === "add") {
        Filters.goToPage(history, location, page + 1, orderBy, orderDirection);
      }
      if(page > 1 && action === "sub"){
        Filters.goToPage(history, location, page - 1, orderBy, orderDirection);
      }
  }

  const header = [
    {
      name: "Id",
      label: "Id",
      canOrder: false,
      breakWord: false,
      render: ({ id }) => <DisplayGuid >{id}</DisplayGuid>,
    },
    {
      name: "Name",
      label: "Name",
      canOrder: true,
      breakWord: false,
      render: ({ name }) => <span>{name}</span>,
    },
    {
      name: "Type",
      label: "Type",
      canOrder: true,
      breakWord: false,
      render: ({ type }) => <span>{type}</span>,
    },
    {
      name: "Action",
      label: "Action",
      render: ({ id }) => (
        <>
          <span>
            <button onClick={async (e) =>
              {if (!confirm('are you sure to delete this Rule?')) {
                                return;
                              }
                await deleteRule(e,id);
              }
            }>
              delete
            </button>
          </span> 
        </>
      ),
    },
  ];

  return (
    <LayoutContext.Consumer>
      {() => (
        <React.Fragment>
          {/* <Notification newMessage={errorMessage} /> */}
          <div className="content-with-right-pane-delimiter">
            <PageTop
              documentTitle="Relay rules"
              documentDescription="Relay rules"
            />
            <h2 className="main-page-header">Relay Rules</h2>
            <Filters
              initFromUrl
              submitUrl
              validateForm={(
                {
                  id,
                  name,
                  type,
                  resultsPerPage
                },
                updatedKey
              ) => {
                if (updatedKey !== "id") {
                  return {
                    id,
                    name,
                    type,
                    resultsPerPage
                  };
                }
                return { id };
              }}
              render={(formData, update) => (
                <div className="filters-block">
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="id">
                      Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name="id"
                      placeholder="Find by id"
                    />
                  </div>
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="name">
                      Rule Name
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name="name"
                      placeholder="Filter by name"
                    />
                  </div>
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="type">
                      Rule Type
                    </label>
                    <FilterSelect
                      data={formData}
                      update={update}
                      name="type"
                      options={relayTypes}
                    />
                  </div>
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="resultsPerPage">
                      Results Per Page
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name="resultsPerPage"
                      placeholder="insert number of result to show per page"
                    />
                  </div>
                  <br />
                  <br />
                  <div className="filters-submit-wrapper">
                    <ButtonOBSOLETED
                      type="submit"
                      buttonContent="Search"
                      disabled={!isLoading}
                    />
                  </div>
                  <hr />
                </div>
              )}
            />
            {loadedData == null ? (
              <span>Loading...</span>
            ) : (
              <>
              <div className="filters-submit-wrapper">
                  <ButtonOBSOLETED
                    onClick={async () => 
                      { 
                        const rule = await props.api.relayRules.addRule();
                        props.history.push('/rule/' + rule.id);
                      }}
                    type="submit"
                    buttonContent="New"
                    disabled={!isLoading}
                  />
              </div>
                <br />
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <input
                    style={navigationButtonStyle}
                    type="button"
                    value="< Prev"
                    onClick={() => pagingHandler("sub")}
                  />
                  <span style={{ color: "grey", fontSize: "0.85rem" }}>
                    Showing page {page} out of {loadedData.pages}
                  </span>
                  <input
                    style={navigationButtonStyle}
                    type="button"
                    value="Next >"
                    onClick={() => pagingHandler("add")}
                  />
                </div>
                <br />
                <article className="data-table-wrap">
                  <table className="data-lists component-data-table cell-content-align-top">
                    <thead>
                      <tr>
                        {header.map((property) => (
                          <td
                            style={property.canOrder ? clickable : null}
                            onClick={() =>
                              typeof property === "object" && property.canOrder
                                ? orderHandler(property.label)
                                : property
                            }
                          >
                            {typeof property === "object"
                              ? property.label
                              : property}{" "}
                            {orderBy.toLowerCase() ===
                            property.label.toLowerCase()
                              ? orderDirection === "desc"
                                ? "↓"
                                : "↑"
                              : ""}
                          </td>
                        ))}
                      </tr>
                    </thead>
                    {loadedData.rules.map((row) => (
                      <tbody>
                        <tr className="hover-listview "
                        onClick={() =>
                      props.history.push(`/rule/${row.id}`)
                  }
                  >
                          {header.map((property) => (
                            <td style={ property.breakWord ? {overflowWrap: 'anywhere'} : {}}>
                              <strong className="table-cell-label">
                                {typeof property === "object"
                                  ? property.label
                                  : property}
                              </strong>
                              {typeof property === "object" ? (
                                property.render(row)
                              ) : property === "Status" ? (
                                <span>{camelToWords(row[property])}</span>
                              ) : (
                                <span>{row[property]}</span>
                              )}
                            </td>
                          ))}
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </article>
              </>
            )}
          </div>
        </React.Fragment>
      )}
    </LayoutContext.Consumer>
  );
};

function camelToWords(text) {
  if (text == null || text == undefined) {
    text = "null";
  }
  const result = text.replace(/([A-Z])/g, " $1");
  return result.charAt(0).toUpperCase() + result.slice(1);
}

const RelayRules = withRouter(
  withApi(
    connect(
      ({ user, categories }) => ({ isLoggedIn: !!user, categories }),
      {}
    )(RelayRulesInternal)
  )
);

RelayRules.requiresLogin = true;
RelayRules.propTypes = { isLoggedIn: PropTypes.bool };

export default RelayRules;
